export const asyncActionMiddleware = (store) => (next) => (action) => {
  if (!action.isAsyncAction) {
    return next(action);
  }

  const state = store.getState();
  const { args: argumentsOfAction } = action;
  const key = action.getKey(...argumentsOfAction)(state);
  const promise = action.getPromise(key);

  if (promise instanceof Promise) {
    return promise;
  }

  const nextResult = next(action.action(...argumentsOfAction));

  action.savePromise(key, nextResult);

  return nextResult;
}
